/**
 * @generated SignedSource<<a5be3959f69fc9134d605815fd412253>>
 * @relayHash b0789fa42ad8fa8340f851edbcc98b58
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/569.0.0-2026-07-21T15:16:11.496Z/PersonalizedCollectionsContextQuery

import { ConcreteRequest } from 'relay-runtime';
export type PersonalizedCollectionsContextQuery$variables = {
  recentlyViewedItemIds: ReadonlyArray<string>;
};
export type PersonalizedCollectionsContextQuery$data = {
  readonly viewer: {
    readonly personalizedCollections: ReadonlyArray<{
      readonly collectionId: string | null;
      readonly itemId: string | null;
      readonly relatedCollections: ReadonlyArray<{
        readonly collectionId: string | null;
      } | null> | null;
    } | null> | null;
  };
};
export type PersonalizedCollectionsContextQuery = {
  response: PersonalizedCollectionsContextQuery$data;
  variables: PersonalizedCollectionsContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recentlyViewedItemIds"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "collectionId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "itemIds",
      "variableName": "recentlyViewedItemIds"
    }
  ],
  "concreteType": "PersonalizedCollection",
  "kind": "LinkedField",
  "name": "personalizedCollections",
  "plural": true,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PersonalizedCollectionsRelated",
      "kind": "LinkedField",
      "name": "relatedCollections",
      "plural": true,
      "selections": [
        (v1/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PersonalizedCollectionsContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PersonalizedCollectionsContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/569.0.0-2026-07-21T15:16:11.496Z/PersonalizedCollectionsContextQuery",
    "metadata": {},
    "name": "PersonalizedCollectionsContextQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e4c02641f4954c3e5620d3341a57bfd9";

export default node;
